(function () {
  'use strict';

  angular.module('app').component('versioningList', versioningList());

  function versioningList() {
    return {
      bindings: {
        appVersions: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowAppVersion: '&',
        additionalLanguages: '<',
      },
      controller: VersioningListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/admin/versioning/versioning-list/versioning-list.component.html',
    };
  }

  VersioningListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'VersioningService',
  ];

  function VersioningListComponent(config, UtilService, AbilityService, VersioningService) {
    var vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_versioning_superadmin'),
      canUpdate: AbilityService.can('update_versioning_superadmin'),
    };

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY_SHORT;

    vm.filterCriteria = VersioningService.getFilterCriteria();

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showAppVersion = showAppVersion;

    function fetchResult() {
      vm.loadingItems = true;

      VersioningService.getAppVersions(vm.filterCriteria).then(function (data) {
        vm.appVersions = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.filterCriteria = VersioningService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showAppVersion(appVersion, mode) {
      // if (!vm.permissions.canShow){
      //     return;
      // }

      vm.onShowAppVersion({ item: appVersion, mode: mode });
    }
  }
})();
